import { useTranslation } from "react-i18next";
import { Button, Navbar, Nav, Form, InputGroup } from "react-bootstrap";

import Logo from "../../assets/img/logo.png";
import bkLogo from "../../assets/img/birkenstock_logo.png";
import hdLogo from "../../assets/img/hey_dude.png";
import tbLogo from "../../assets/img/ted_baker.png";
import dcLogo from "../../assets/img/digicape_logo_black.png";
import htLogo from "../../assets/img/hi-tec.svg"; 
import crLogo from "../../assets/img/crocs_logo_new.png"
import okLogo from "../../assets/img/oakley_logo.png"
import vaLogo from "../../assets/img/va-logo.png";
import uaLogo from "../../assets/img/ua-logo.png";
import sumpLogo from "../../assets/img/sump_logo.png";


import useSidebar from "../../hooks/useSidebar";
import { Logout } from "../auth/Logout";
import { useAuth, UserDetail} from "../../contexts/AuthContext";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

// import NavbarDropdown from "./NavbarDropdown";
// import NavbarDropdownItem from "./NavbarDropdownItem";
// import NavbarLanguages from "./NavbarLanguages";
// import NavbarThemeToggle from "./NavbarThemeToggle";
// import NavbarUser from "./NavbarUser";

const NavbarComponent = () => {
	
	const { t } = useTranslation();
	const { isOpen, setIsOpen } = useSidebar();
	const {userDetail , fetchData}  = useAuth();
	const navigate = useNavigate();

	let customerLogo = Logo;


	if(process.env.REACT_APP_COMPANY === "ares-bk") {
		customerLogo = bkLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-hd") {
		customerLogo = hdLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-tb") {
		customerLogo = tbLogo;
	}

	if(process.env.REACT_APP_COMPANY === "digicape" || process.env.REACT_APP_COMPANY === "stockanywhere-digicape") {
		customerLogo = dcLogo;
	}

	if(process.env.REACT_APP_COMPANY === "hi-tec" || process.env.REACT_APP_COMPANY === "stockanywhere-hi-tec") {
		customerLogo = htLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-cr") {
		customerLogo = crLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-ok") {
		customerLogo = okLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-va") {
		customerLogo = vaLogo;
	}

	if(process.env.REACT_APP_COMPANY === "ares-ua") {
		customerLogo = uaLogo;
	}

	if(process.env.REACT_APP_COMPANY === "stockanywhere-sump") {
		customerLogo = sumpLogo;
	}

	useEffect(() => {
		// console.log("UserDetails:");
		// console.log(userDetail);
	}, [userDetail]);

	useEffect(() => {
		const loggedInUrl: string = process.env.REACT_APP_LOGGED_IN_URL as string;
        
		fetchData(loggedInUrl, {method:"GET"}, (result: any) => {
		});
	}, [])

	const getLogoWidth = (company: string | undefined) => {
		switch (company) {
			case "ares-hd":
			return 50;
			case "ares-cr":
			return 120;
			case "ares-ok":
			case "ares-va":
			return 90;
			case "ares-ua":
			return 60;
			case "ares-tb":
			return 99;
			case "stockanywhere-sump":
			return 80;
			default:
			return 120;
		}
	};

	const company = process.env.REACT_APP_COMPANY;
	const logoWidth = getLogoWidth(company);


	return (
		<Navbar variant="light" expand className="navbar-bg">
			{ /* sidebar-toggle => was in classname */ }
			<span className=" d-flex" onClick={() => setIsOpen(!isOpen)}
				style={{ paddingRight:"15px", height: "40px", width:"40px", cursor: "pointer" }}>
				<i className="hamburger align-self-center" />
			</span>
			 <>
			    <span></span>
		        <Link to="/" className="p-0">
				  <img src={customerLogo} style={{ width: `${logoWidth}px` }} alt="Logo" />
			    </Link>
		  	</>
			<div className="d-flex justify-content-end w-100 gap-3 align-items-center ps-3" >
				<div className="d-flex justify-content-left w-100 gap-3 align-items-center" >
					<span>{`Welcome ${userDetail?.firstName ? userDetail.firstName : ''} ${userDetail?.lastName ? userDetail.lastName : ''} [${userDetail?.userName}]`}</span>	
				</div>
				<Logout />		
				<button onClick={() => navigate("/")} className="p-0 border-0 bg-transparent" style={{ cursor: 'pointer' }}>
			    	<img src={Logo} style={{ width: '200px', marginBottom: "-7px" }} alt="Home" />
				</button>
			</div>
		</Navbar>
	);
};

export default NavbarComponent;


